import React, {useCallback, useEffect, useState} from 'react';
import useDeepCompareEffect from "use-deep-compare-effect";
import {SCRIPTS_LOADED, useModelviewerDispatch} from "./useModelviewerContext";
import {useModelviewerScripts} from "./useModelviewerScripts";

const microfrontendUrl = (url) => {
    if(url) {
        return url
    }else if(!window._env_ || !window._env_.MICROFRONTEND_MODELVIEWER_URL) {
        throw new Error("Microfrontend host must be configured in window._env_.MICROFRONTEND_MODELVIEWER_URL")
    } else {
        return window._env_.MICROFRONTEND_MODELVIEWER_URL;
    }
}

export const WithModelviewerMicroFrontend = ({url=null, children}) => {
    const dispatch = useModelviewerDispatch();
    const dispatchCallback = useCallback(dispatch, []);
    const [scriptsLoaded, setScriptsLoaded] = useState(-1);
    const host = microfrontendUrl(url);
    const {scripts, styles} = useModelviewerScripts(host);

    useDeepCompareEffect(() => {
        if(scripts.length) {
            setScriptsLoaded(-1 * scripts.length)
            scripts.forEach(script => {
                const scriptElement = document.createElement('script')
                scriptElement.id = `modelviewer-microfrontend-${script.scriptName}`
                scriptElement.src = `${host}/${script.entrypoint}`
                scriptElement.onload = () => setScriptsLoaded(sl => 1 + sl);
                document.head.appendChild(scriptElement);
            })

            return () => {
                scripts.forEach(script => {
                    const scriptId = `modelviewer-microfrontend-${script.scriptName}`
                    const scriptElement = document.getElementById(scriptId)
                    document.head.removeChild(scriptElement)
                })
            }
        }
    }, [scripts])

    useDeepCompareEffect(() => {
        if(styles.length) {
            styles.forEach(style => {
                const linkElement = document.createElement('link')
                linkElement.id = `modelviewer-microfrontend-microfrontend-${style.styleName}`
                linkElement.href = `${host}/${style.entrypoint}`
                linkElement.rel = "stylesheet"
                document.head.appendChild(linkElement);
            })

            return () => {
                styles.forEach(style => {
                    const scriptId = `modelviewer-microfrontend-microfrontend-${style.styleName}`
                    const linkElement = document.getElementById(scriptId)
                    document.head.removeChild(linkElement)
                })
            }
        }
    }, [styles])

    useEffect(() => {
        if(0 === scriptsLoaded) {
            dispatchCallback({type: SCRIPTS_LOADED})
        }
    }, [scriptsLoaded, dispatchCallback])

    return (
        <>
            {children}
        </>
    )
}